import { Injectable, Injector } from '@angular/core';
import { StorageService } from './storage.service';
import { storage } from '../utils/catalog';
import migrations from '../migrations';

@Injectable({
  providedIn: 'root',
})
export class MigrationService {
  private storageService: StorageService;

  constructor(private injector: Injector) {
    this.storageService = injector.get(StorageService);
  }

  public async init() {
    const lastMigrationNumber = this.storageService.get(storage.keys.migration, 0);

    const validMigrations = migrations.filter((m) => m.number > lastMigrationNumber);
    if (!validMigrations.length) return;

    const lastValidMigration = validMigrations[validMigrations.length - 1];
    if (!lastValidMigration) return;

    for (let validMigration of validMigrations) {
      await validMigration.up(this.injector);
      console.log(`---migration ${validMigration.number} migrated---`);
    }

    this.storageService.put(storage.keys.migration, lastValidMigration.number);
  }
}
